import { useEffect, useState } from 'react';
import apiClient from '../../services/apiClientService';
import useErrorHandler from '../../hooks/useErrorHandler';
import { useTenant } from '../../contexts/TenantContext';

const useCompleteRegistration = () => {
  const { tenantId } = useTenant();
  const [loading, setLoading] = useState(false);
  const { handleError } = useErrorHandler();

  // Back to this page, the browser may restore it as it was left, button spinning.
  useEffect(() => {
    const resetOnRestore = (event) => event.persisted && setLoading(false);
    window.addEventListener('pageshow', resetOnRestore);
    return () => window.removeEventListener('pageshow', resetOnRestore);
  }, []);

  // On success the page is left for the redirect URL, so the button keeps spinning until it goes.
  const completeRegistration = async (requestData) => {
    setLoading(true);

    try {
      const url = `/v1/tenants/${tenantId}/auth/complete-registration`
      const response = await apiClient.put(url, requestData);
      const redirectUrl = response?.data?.redirectUrl;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        setLoading(false);
        handleError({ message: "Sajnos nem sikerült a véglegesíteni regisztrációt. Foglalj időpontot telefonon keresztül." });
      }
    } catch (error) {
      setLoading(false);
      handleError(error)
    }
  };

  return { loading, completeRegistration };
};

export default useCompleteRegistration;
